import omitProps from '../../HigherOrderComponents/omitProps';

const props = ['format', 'formatChar', 'internalValidation'];

const protectedProps = (Component) => omitProps(props)(Component);

export default protectedProps;
